<template>
  <button
    :class="`filters-button ${active ? 'active' : ''}`"
    @click="handle_click"
  >
    <vb-icon
      v-if="icon"
      class="filters-button--icon"
      :name="icon"
      :size="19"
      :color="sass('info')"
      :icon_style="{
        '--color': sass('info'),
      }"
    />
    <div class="filters-button--button-text">
      <div>{{ text }}</div>
      <div v-if="sub_text" class="filters-button--button-subtext">
        {{ sub_text }}
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: "filters-button",
  props: {
    text: String,
    icon: {
      type: String,
      default: () => "",
    },
    sub_text: {
      type: String,
      default: () => "",
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handle_click(e) {
      this.$emit("click", e);
      this.scroll_top();
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-button {
  background-color: white;
  display: flex;
  align-items: center;
  min-width: 100%;
  border: 1px solid $gray-200;
  border-radius: $rounded-pill;
  padding: $grid-gutter-width/3 20px;
  transition: $transition-base;
  cursor: pointer;
  font-size: $font-size-md;
  line-height: 120%;

  &:hover {
    background-color: $gray-100;
    border-color: $gray-300;
  }

  &.active {
    color: var(--info);
    border-color: var(--info);
  }

  &--icon {
    margin-right: 12px;
    flex-shrink: 0;
  }

  &--button {
    &-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &-subtext {
      font-size: $font-size-sm;
      opacity: 0.8;
    }
  }
}
</style>
